import React from 'react';
import {
  ViewButton,
  EditButton,
  TestQueryButton,
  GoogleSpreadsheetButton,
} from '../Common/DataTable/tableActionButtons';
import { getFilter, getLabel, getSort } from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const getName = (cell, collections) => {
  const document = collections.find((document) => document.id === cell);
  return document ? document.name : '';
};

const createTableColumns = (
  customers,
  sales,
  openViewModal,
  openEditModal,
  openTestQueryModal,
) => [
  {
    title: 'Name',
    name: 'name',
    width: 240,
  },
  {
    title: 'Customer',
    name: 'customerId',
    formatterComponent: ({ value }) => getLabel(value, customers),
    sorting: (a, b) => getSort(getLabel(a, customers), getLabel(b, customers)),
    filter: (value, filter) =>
      getFilter(getLabel(value, customers), filter.value),
  },
  {
    title: 'Sale',
    name: 'supplierId',
    formatterComponent: ({ value }) => getLabel(value, sales),
    sorting: (a, b) => getSort(getLabel(a, sales), getLabel(b, sales)),
    filter: (value, filter) => getFilter(getLabel(value, sales), filter.value),
  },
  {
    title: 'Start Date',
    name: 'startDate',
    width: 120,
    formatterComponent: ({ value }) => moment(value).format('DD/MM/YYYY'),
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(moment(value).format('DD/MM/YYYY'), filter.value),
  },
  {
    title: 'End Date',
    name: 'endDate',
    width: 120,
    formatterComponent: ({ value }) => moment(value).format('DD/MM/YYYY'),
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(moment(value).format('DD/MM/YYYY'), filter.value),
  },
  {
    title: 'Active',
    name: 'active',
    width: 100,
    sort: true,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-danger font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'yes' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'yes' : 'no', b ? 'yes' : 'no'),
  },
  {
    title: 'Payout',
    name: 'payout',
    width: 100,
    formatterComponent: ({ value }) => `€ ${value}`,
  },
  {
    title: 'Positive Closure',
    name: 'costPositiveClosure',
    width: 100,
    formatterComponent: ({ value }) => `€ ${value}`,
  },
  {
    title: 'Action',
    name: 'action',
    width: 180,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        {row.googleSpreadsheetId !== 'processing' && (
          <EditButton row={row} onPress={openEditModal} />
        )}
        {row.query !== '' && (
          <TestQueryButton row={row} onPress={openTestQueryModal} />
        )}
        {row.googleSpreadsheetId &&
          !['new', 'processing', 'error'].includes(row.googleSpreadsheetId) && (
            <GoogleSpreadsheetButton row={row} />
          )}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
